// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:36:01

export default {
  "id": "farm-block",
  "slug": "farm-block",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/b3e72ad35cfe4313b674870911c57d46-512x512.jpg",
  "gameUrl": "https://html5.gamedistribution.com/b3e72ad35cfe4313b674870911c57d46/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Farm Block",
      "description": "Farm Block is an engaging farm-themed puzzle game where players slide adorable animal blocks to free them from the farm. Test your strategic thinking and enjoy the charming countryside setting! With its mix of puzzle-solving and elimination mechanics, Farm Block offers a fun and rewarding challenge for all ages.",
      "instructions": "1️⃣ Slide animal blocks in the right direction to create space.\n2️⃣ Match & Eliminate blocks strategically to clear the path.\n3️⃣ Solve Puzzles with increasing difficulty levels.\n4️⃣ Escape the Farm! Complete levels and rescue all the animals.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "animal",
        "cow",
        "farm",
        "horse"
      ]
    },
    "zh-CN": {
      "title": "农场方块",
      "description": "农场方块是一款引人入胜的以农场为主题的益智游戏，玩家需要滑动可爱的动物方块，将它们从农场中释放出来。测试你的战略思维，享受迷人的乡村环境！结合解谜和消除机制，农场方块为所有年龄段提供有趣且富有挑战性的游戏体验。",
      "instructions": "1️⃣ 将动物方块滑动到正确的方向以创造空间。\n2️⃣ 策略性地匹配和消除方块以清除路径。\n3️⃣ 以不断增长的难度级别解决谜题。\n4️⃣ 从农场逃脱！完成关卡并拯救所有动物。",
      "genres": [
        "休闲",
        "解谜"
      ],
      "tags": [
        "1玩家",
        "动物",
        "牛",
        "农场",
        "马"
      ]
    },
    "zh-TW": {
      "title": "農場塊",
      "description": "農場塊是一款引人入勝的農場主題拼圖遊戲，玩家需滑動可愛的動物塊來釋放它們從農場中。挑戰你的策略思維，並享受迷人的鄉村景觀！結合解謎與消除機制，農場塊為所有年齡層提供一個有趣且獎勵豐厚的挑戰！",
      "instructions": "1️⃣ 擺放動物積木至正確方向以創造空間。\n2️⃣ 策略性地匹配與消除積木以清除道路。\n3️⃣ 解開隨著難度提升的謎題。\n4️⃣ 離開農場！完成關卡並救出所有動物。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1 玩家",
        "動物",
        "牛",
        "农場",
        "馬"
      ]
    },
    "zh-HK": {
      "title": "農場方塊",
      "description": "農場快樂盡是款引人入勝的農場主題益智遊戲，玩家需將可愛的動物積木滑動，從農場中解放它們。考驗你的策略思考，並享受迷人鄉村景緻！結合了解謎與消除機制，農場快樂盡為所有年齡層提供好玩又獎勵豐厚的挑戰！",
      "instructions": "1️⃣ 尋找正確方向移動動物方塊，以創造空間。\n2️⃣ 策略性地匹配及消除方塊，清空道路。\n3️⃣ 以逐漸增加難度的級別解開謎題。\n4️⃣ 離開農場！完成關卡並救出所有動物。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "動物",
        "牛",
        "農場",
        "馬"
      ]
    },
    "ja": {
      "title": "ファームブロック",
      "description": "ファームブロックは、可愛い動物ブロックを滑らせて農場から解放する、楽しい農場テーマのパズルゲームです。戦略的な思考を試しながら、魅力的な田園風景を楽しみましょう！パズル解決と排除メカニクスの組み合わせで、全ての年齢層に楽しめる楽しい挑戦を提供します。",
      "instructions": "1️⃣ 正しい方向に動物ブロックをスライドさせ、空間を作り出せ。\n2️⃣ 战略的にブロックを一致させ、排除し、道を開ける。\n3️⃣ 減少する難易度レベルのパズルを解く。\n4️⃣ 农場から逃げ出せ！レベルを完了し、すべての動物を救出せ。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "動物",
        "牛",
        "農場",
        "馬"
      ]
    },
    "ko": {
      "title": "농장 블록",
      "description": "퍼프 블록은 농장 주제의 매력적인 퍼즐 게임으로, 플레이어는 귀여운 동물 블록을 이동하여 농장에서 풀어내는 게임입니다. 전략적 사고를 테스트하고, 매력적인 농촌 풍경을 즐겨보세요! 퍼즐 해결과 제거 기계의 혼합으로, 퍼프 블록은 모든 연령대에게 즐거움과 보상을 제공하는 도전입니다.",
      "instructions": "1️⃣ 정확한 방향으로 동물 블록을 드래그하여 공간을 만들어주세요.\n2️⃣ 전략적으로 블록을 매칭하고 제거하여 길을 효율적으로 청소하세요.\n3️⃣ 증가하는 난이도 레벨로 퍼즐을 해결하세요.\n4️⃣ 농장을 탈출하세요! 레벨을 완료하고 모든 동물을 구출하세요.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "동물",
        "소",
        "농장",
        "말"
      ]
    },
    "fr": {
      "title": "Ferme Bloc",
      "description": "Farm Block est un jeu de puzzle à thème de ferme captivant où les joueurs glissent des blocs d'animaux adorable pour les libérer de la ferme. Testez votre pensée stratégique et profitez du cadre charmant de la campagne ! Avec son mélange de mécanismes de résolution de puzzles et d'élimination, Farm Block propose un défi amusant et gratifiant pour tous les âges.",
      "instructions": "1️⃣ Faites glisser les blocs d'animaux dans la bonne direction pour créer de l'espace.\n2️⃣ Association et élimination stratégique des blocs pour dégager le chemin.\n3️⃣ Résolvez des puzzles avec des niveaux de difficulté croissants.\n4️⃣ Échappez-vous à la Ferme ! Terminez les niveaux et sauvez tous les animaux.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "animal",
        "vache",
        "ferme",
        "cheval"
      ]
    }
  }
};
